module.exports = __webpack_public_path__ + "static/media/span.4d777368.svg";